import { Typography } from '@mui/material'
import { Link } from 'react-router'

const AccessDeniedMessage = () => (
  <Typography sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '60vh', fontSize: '16px', textAlign: 'center' }}>
     Sorry, You do not have access to this page.<br />
     Please contact Acumen for access.<br />
    <Link to="/leases">Go Back</Link>
  </Typography>
)

export default AccessDeniedMessage
